var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridButton',{attrs:{"tag-name":"button","content":_vm.content,"type":_vm.type,"is-disabled":_vm.isLoadingStripeScript},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }